import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { ActionStatus } from '../../../common/constants/action-status';
import { PromoCodeDiscountState } from '../../promo-code/interfaces/promo-code.interface';
import { redeemUpsellOffer } from '../thunks/redeem-upsell-offer.thunk';

/**
 * Updates the promo code state based on the result of the redeem upsell offer action.
 *
 * @param builder
 */
export function addRedeemUpsellOfferReducers(builder: ActionReducerMapBuilder<PromoCodeDiscountState>): void {
  builder
    .addCase(redeemUpsellOffer.pending, (state): void => {
      state.updatePromoCode.status = ActionStatus.loading;
    })
    .addCase(redeemUpsellOffer.fulfilled, (state, action): void => {
      state.updatePromoCode.status = ActionStatus.succeeded;
      state.updatePromoCode.data = action.payload;
      state.updatePromoCode.error = undefined;
    })
    .addCase(redeemUpsellOffer.rejected, (state, action: any): void => {
      state.updatePromoCode.status = ActionStatus.failed;
      state.updatePromoCode.error = action.payload;
    });
}

